// removed by extract-text-webpack-plugin
module.exports = {"NavContainer":"navbar__NavContainer__3QzE0","Fixed":"navbar__Fixed__3Y3gC navbar__NavContainer__3QzE0","EditorNavContainer":"navbar__EditorNavContainer__1l1jw navbar__NavContainer__3QzE0","WorkspaceNav":"navbar__WorkspaceNav__21cLF navbar__NavContainer__3QzE0","LogoContainer":"navbar__LogoContainer__1MdpG","Logo":"navbar__Logo__3YJnB","LogoShort":"navbar__LogoShort__5ZQys","NavListContainer":"navbar__NavListContainer__Bc8JK"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/navbar.css
// module id = 884
// module chunks = 2